import { Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BaseControl } from '../../base/base-control';

@Component({
    selector: 'app-email-input',
    standalone: true,
    templateUrl: './email-input.component.html',
    styleUrl: './email-input.component.scss',
    imports: [MatFormFieldModule, MatInputModule],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EmailInputComponent),
            multi: true
        }]
})
export class EmailInputComponent extends BaseControl<string> {

}
